import { getApiClient } from './apiClient'
import axios from 'axios'

const apiClient = getApiClient(process.env.REACT_APP_REPORT_API_URL)

export const getReportPayloadURL = (customerId, reportType) => {
  return apiClient.post('/reports', {
    customerId,
    reportType
  })
}

export const createReport = async (url, id, customerId, reportType, data) => {
  const itemizedData = {
    itemized_bom: data.itemized_bom
  }

  if (itemizedData.itemized_bom) {
    itemizedData.summary_shutdown_screen = data.summary_shutdown_screen
  } else {
    itemizedData.Summary_of_Shutdown_Parts = data.ItemsSummary
  }

  return axios.put(url, {
    content: {
      Example_Data: {
        Report_Title: data.Title,
        Customer_Name: data.Company,
        Site_Name: data.Site,
        Date_of_Visit: data.DateOfVisit,
        Sandvik_Rep: data.SiteRepresentative,
        SiteRepresentative: data.SiteRepresentative,
        Site_Contact: data.SiteContact,
        Scope_of_Work: data.ScopeOfWork,
        Safety_Issues: data.SafetyIssues,
        Crew_Details: data.CrewDetails,
        contact_information: data.contact_information,
        contact_information_night: data.contact_information_night,
        contact_information_Day: data.contact_information_Day,
        Introduction: data.Introduction,
        Summary_of_Equipment: data.Inspections.map((inspection) => {
          delete inspection.PostLayout
          delete inspection.PreLayout
          delete inspection.DefaultLayout

          return {
            ...inspection
          }
        }),
        Shutdown_Comments: data.ShutdownComments,
        Recommendations: data.Recommendations,
        ...itemizedData,
        Summary_of_Shutdown_Parts: data.ItemsSummary,
        Wear_Report: data.wearReport
      }
    },
    $dict: {},
    $report: {
      binding: true,
      pageCount: 0,
      toc: []
    },
    customerId,
    reportType,
    id
  })
}

export const getReportStatus = (id) => apiClient.get(`/reports/${id}/`)
